export const Period = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
} as const

export type Period = (typeof Period)[keyof typeof Period]

export const PeriodLabel = {
  [Period.DAY]: 'Día(s)',
  [Period.WEEK]: 'Semana(s)',
  [Period.MONTH]: 'Mes(es)',
  [Period.YEAR]: 'Año(s)'
} as const satisfies Record<Period, string>
